"use client";


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollReveal from "./ScrollReveal";


gsap.registerPlugin(ScrollTrigger);

export default function AboutUsSection() {

    return (
        <section
            className="sm:px-16 px-4 sm:pb-[100px] pb-10 max-w-[1490px] w-full h-full mx-auto relative"
            id="aboutus"
        >
            <ScrollReveal>
                {/* Glow background */}
                <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full 
                bg-yellow-500/20 blur-[160px] -z-10" />

                <div className="text-center text-white">
                    {/* Title */}
                    <h2 className="sectionTitle reveal-item">
                        About Us
                    </h2>

                    {/* Intro */}
                    <p
                        className="reveal-item heading2 max-w-3xl mx-auto mt-4 text-justify lg:text-center"
                    >
                        We are a passionate game studio crafting experiences that connect
                        people worldwide. We belief games
                        inspire, entertain and bring communities closer together.
                    </p>

                    {/* Split Layout */}
                    <div className="mt-16 grid lg:grid-cols-2 gap-12 items-center mb-0">
                        {/* Lottie / Illustration */}
                        <div className="reveal-item flex w-full h-full justify-center items-center">
                            <img
                                alt="About Us Image"
                                src="/aboutus.jpeg"
                                className="w-full rounded-2xl"
                            />
                        </div>

                        {/* Values */}
                        <div className="space-y-8 text-left">
                            <div>
                                <h3 className="reveal-item text-2xl font-semibold text-yellow-400 mb-2">
                                    Creativity First
                                </h3>
                                <p className="text-lg font-semibold leading-relaxed reveal-item">
                                    Innovation is at the core of everything we build. We thrive on
                                    new ideas and bold experimentation.
                                </p>
                            </div>

                            <div>
                                <h3 className="reveal-item text-2xl font-semibold text-yellow-400 mb-2">
                                    Global Community
                                </h3>
                                <p className="text-lg font-semibold leading-relaxed reveal-item">
                                    Our games are designed for everyone, everywhere. We embrace
                                    diversity and celebrate different cultures.
                                </p>
                            </div>

                            <div>
                                <h3 className="text-2xl font-semibold text-yellow-400 mb-2 reveal-item">
                                    Growth & Collaboration
                                </h3>
                                <p className="text-lg font-semibold leading-relaxed reveal-item">
                                    We believe in supporting one another and learning together to
                                    become the best creators we can be.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollReveal>
        </section>
    );
}
